import { createRequest } from "helpers/tools";

export const getGoogleDmaAuthUrl = async (type) => {
    return await createRequest({
        suffix: `destinations/google-dma/auth-url`,
        handleError: true,
        method: "get",
        params: { type },
    });
};

export const postAuthorizeGoogleDma = async (payload) => {
    return await createRequest({
        suffix: `destinations/google-dma/authorize`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const postSaveGoogleDma = async (payload) => {
    return await createRequest({
        suffix: `destinations/google-dma/save`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const getGoogleDmaConversions = async (destinationId) => {
    return await createRequest({
        suffix: `destinations/google-dma/${destinationId}/conversions`,
        handleError: false,
        method: "get",
    });
};

export const getGoogleDmaMappings = async (destinationId) => {
    return await createRequest({
        suffix: `destinations/google-dma/${destinationId}/mappings`,
        handleError: false,
        method: "get",
    });
};

export const postGoogleDmaMappings = async (destinationId, payload) => {
    return await createRequest({
        suffix: `destinations/google-dma/${destinationId}/mappings`,
        handleError: true,
        method: "post",
        payload,
    });
};
